import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCallingV2Service, API_CONFIG } from '@zayan-erp/shared';

@Injectable({ providedIn: 'root' })
export class DsmProjectDepositScheduleService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  #baseUrl = this.#apiConfig.baseUrlV2;

  getDepositsByProject(projectId: string): Observable<unknown> {
    return this.#http.getData(`${this.#baseUrl}/deposit-schedules/project/${projectId}`, {
      showLoader: true,
      showMessage: false
    });
  }
}
